import React, { useEffect, useRef, useState } from 'react';
import { images } from '../utils/images';

const CommunityParticipation = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const activities = [
    {
      id: 1,
      image: images.fishing,
      title: "Outdoor Activities",
      description: "Enjoy nature and build skills through fishing, hiking, and outdoor adventures"
    },
    {
      id: 2,
      image: images.beach,
      title: "Sports & Recreation",
      description: "Participate in inclusive sports activities and beach fun for all abilities"
    },
    {
      id: 3,
      image: images.cooking,
      title: "Life Skills Development",
      description: "Learn cooking, meal preparation, and independent living skills in a supportive environment"
    }
  ];

  return (
    <section 
      ref={sectionRef}
      className={`py-20 bg-white transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 
            className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6"
            style={{ color: '#587740' }}
          >
            Community Participation & Activities
          </h2>
          <p 
            className="text-lg md:text-xl"
            style={{ color: '#5e5e5e' }}
          >
            We believe in active community engagement and building life skills through meaningful 
            activities that promote independence, social connection, and personal growth.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {activities.map((activity, index) => (
            <div 
              key={activity.id}
              className={`group transition-all duration-500 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className="relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300">
                <div className="relative h-80 overflow-hidden">
                  <img 
                    src={activity.image}
                    alt={activity.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/50 to-black/20" />
                  
                  {/* Content overlay */}
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                    <h3 className="text-2xl font-bold mb-2">
                      {activity.title}
                    </h3>
                    <p className="text-sm leading-relaxed text-gray-200">
                      {activity.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional info section */}
        <div className="mt-16 max-w-4xl mx-auto text-center">
          <div 
            className="p-8 rounded-2xl"
            style={{ backgroundColor: '#f8f9fa' }}
          >
            <h3 
              className="text-2xl font-bold mb-4"
              style={{ color: '#587740' }}
            >
              Building Connections, Creating Opportunities
            </h3>
            <p 
              className="text-lg leading-relaxed"
              style={{ color: '#5e5e5e' }}
            >
              Our community participation programs are designed to help you connect with others, 
              develop new skills, and explore your interests. From outdoor adventures to life skills 
              training, we support you every step of the way.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommunityParticipation;
